/**
 * @generated SignedSource<<4efd5a53413717b0d68f9e9748182492>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Row_issueEdge$data = {
  readonly node: {
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"RowInner_issueEdge" | "RowMaybeWithDragAndDrop_issueEdge" | "RowWithDragAndDrop_issueEdge" | "RowWithSiblingCreate_issueEdge">;
  readonly " $fragmentType": "Row_issueEdge";
};
export type Row_issueEdge$key = {
  readonly " $data"?: Row_issueEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"Row_issueEdge">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "isDensityFull",
    "variableName": "isDensityFull"
  },
  {
    "kind": "Variable",
    "name": "isLinkRelationshipFieldEnabled",
    "variableName": "isLinkRelationshipFieldEnabled"
  },
  {
    "kind": "Variable",
    "name": "isRemoteLinkedIssuesEnabled",
    "variableName": "isRemoteLinkedIssuesEnabled"
  },
  {
    "kind": "Variable",
    "name": "isReparentingEnabled",
    "variableName": "isReparentingEnabled"
  },
  {
    "kind": "Variable",
    "name": "projectKey",
    "variableName": "projectKey"
  },
  {
    "kind": "Variable",
    "name": "projectKeys",
    "variableName": "projectKeys"
  },
  {
    "kind": "Variable",
    "name": "shouldQueryHasChildren",
    "variableName": "shouldQueryHasChildren"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isLinkRelationshipFieldEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isRemoteLinkedIssuesEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isReparentingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shouldQueryHasChildren"
    }
  ],
  "kind": "Fragment",
  "name": "Row_issueEdge",
  "selections": [
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "RowInner_issueEdge"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "RowWithSiblingCreate_issueEdge"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "RowMaybeWithDragAndDrop_issueEdge"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "RowWithDragAndDrop_issueEdge"
    },
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        }
      ]
    }
  ],
  "type": "JiraIssueEdge"
};
})();

(node as any).hash = "d9df20eb58b51c0f60df6f3b02d6583f";

export default node;
